import { gql } from '@apollo/client';

export const GET_USER = gql`
  query getUserProfileCa {
    getUserProfileCa {
      status
      message
      data {
        compliance
        id
        dob
        firstName
        lastName
        otherName
        email
        imageUrl
        isPhoneVerified
        gender
        phone
        location {
          countryName
          city
          date
        }
        userDevices {
          city
          country
          createdAt
          date
          deviceId
          deviceModel
          deviceOS
          deviceType
          id
          updatedAt
          userId
        }
        tenant {
          stripePaymentMethodId
          stripePADSubscriptionId
          leaseDuration
          leaseEndDate
          leaseStartDate
          paymentStatus
          rentProtection
          PADStatus
          id
          isActive
          account {
            id
          }
          property {
            rentalAddress
          }
          unit
          rentAmount
          rentDueDay
          landlord {
            firstName
            lastName
            email
            phone
            noOfUnits
            meta
            documents {
              docKey
              documentId
              documentType
              expireDate
              fileName
              file_ext
              frontImage
              id
              issueDate
              meta {
                contentType
                docOption
                file_size
                isOthers
              }
              note
              provider
              realtorId
              reason
              status
              test
              updatedAt
              uri
              backImage
            }
          }
        }
        rentDetails {
          tenant {
            id
            isActive
            PADStatus
            account {
              updatedAt
              type
              transitCode
              realtorId
              providerCustomerId
              id
              email
              createdAt
              bankName
              bankId
              bankBranchId
              accountNumber
            }
            property {
              rentalAddress
            }
            unit
            rentAmount
            rentDueDay
            landlord {
              firstName
              lastName
              email
              phone
              noOfUnits
              meta
              documents {
                docKey
                documentId
                documentType
                expireDate
                fileName
                file_ext
                frontImage
                id
                issueDate
                meta {
                  contentType
                  docOption
                  file_size
                  isOthers
                }
                note
                provider
                realtorId
                reason
                status
                test
                updatedAt
                uri
                backImage
              }
            }
          }
          property {
            id
            landlord {
              phone
              email
              companyName
              firstName
              landlordType
              lastName
            }
            landlord_e_transfer_email
            landlordModeOfPayment
            leaseAgreementDoc
            monthlyDueDay
            rentAmount
            unitNumber
            hasleaseAgreementDoc
            propertyAddress
          }
        }
        productNotifications {
          createdAt
          id
          isNotified
          productCode
          productName
          updatedAt
          userId
        }
        primaryAddress {
          city
          location
          country
          zipCode
        }
        documents {
          id
          docKey
          documentType
          frontImage
          backImage
          uri
          reason
          issueDate
          status
          docKey
          fileName
          documentId
          description
          note
          meta {
            file_size
            contentType
            docOption
            isOthers
          }
        }
        apartmentDetails {
          additionalInformation
          apartmentType
          city
          id
          lastActionedAt
          lastActionedBy
          meta
          monthlyBudget
          monthlyIncome
          paymentAmount
          province
          refundedAt
          status
          userId
          currentLocation
        }
        userRtDetail {
          isPGWPEligible
          selfie
          flight_answer
          flight_question
          degree
          campus
          institution_city
          institution_name
          institution_province
          meta
          nationality
          studentEmail
          userId
          product
          id
          enrolled_as_student
          enrollment_type
          enrollment_type_other
          onboardingStatus
          employment_status
          monthly_income
          creditBuilderStatus
        }
        rentGuarantees {
          amount
          annualIncome
          approvedBy
          cities
          createdAt
          currency
          downPayment
          guaranteeApprovedAt
          guaranteeEndDate
          guaranteeStartDate
          guaranteeType
          id
          meta
          monthlyRent
          outstandingBalance
          paymentPlan
          preApprovalDocUrl
          province
          status
          tenor
          updatedAt
          userId
          property {
            city
            country
            createdAt
            currency
            hasleaseAgreementDoc
            id
            landlordId
            landlordModeOfPayment
            landlord_e_transfer_email
            leaseAgreementDoc
            leaseStartDate
            meta
            monthlyDueDay
            postalCode
            propertyAddress
            rentAmount
            unitNumber
            updatedAt
            userId
            landlord {
              companyName
              email
              firstName
              id
              landlordType
              lastName
              phone
              website
            }
          }
        }
        employmentdetail {
          employmentStatus
          monthlyIncome
        }
      }
    }
  }
`;

export const GET_INSTITUTION_DETAILS = gql`
  query getInstutionDetails {
    getInstutionDetails {
      status
      message
      data
    }
  }
`;

export const GET_USER_UPCOMING_REPAYMENT = gql`
  query Repayment($offset: Int, $limit: Int) {
    getUserUpcomingRepayment(offset: $offset, limit: $limit) {
      amountDue
    }
  }
`;

export const GET_ALL_PURCHASE = gql`
  query GetAllPurchases(
    $limit: Int
    $offset: Int
    $filter: String
    $search: String
    $sort: SortInput
  ) {
    getAllPurchases(limit: $limit, offset: $offset, filter: $filter, search: $search, sort: $sort) {
      count
      loans {
        id
        dueDate
        createdAt
        amount
        paymentChannel
        loanChannel
        interest
        loanStatusId
        loanStatus {
          name
        }
        merchant {
          name
          logo
        }
        order {
          id
          amount
          orderNumber
          paymentMethod
          items
          status {
            id
            name
          }
          merchant {
            name
            logo
          }
          orderItems {
            orderName
            amount
            orderId
          }
        }
      }
    }
  }
`;

export const GET_USER_TRANSACTIONS = gql`
  query GetUserTransactions($search: String, $limit: Int, $offset: Int, $type: String) {
    getUserTransactions(search: $search, limit: $limit, offset: $offset, type: $type) {
      count
      transactions {
        id
        type
        description
        narration
        message
        userId
        paymentRef
        txRef
        signature
        paymentMethod
        amount
        currency
        orderId
        transactionId
        statusCode
        instalmentSequence
        paymentFor
        merchantId
        settlementStatus
        transSettlementDate
        amountPaid
        domain
        gatewayResponse
        request
        vendorId
        ipAddress
        cardBin
        cardLast4
        fees
        paidAt
        createdAt
        updatedAt
        code
        meta
        settlementId
        merchant {
          name
        }
        status
        channel
      }
    }
  }
`;

export const GET_USER_REPAYMENTS_BY_LOAN_ID = gql`
  query GetUserRepaymentsByLoanId($loanId: String) {
    getUserRepaymentsByLoanId(loanId: $loanId) {
      id
      dueDate
      amountDue
      isFullyPaid
    }
  }
`;

export const GET_USER_REPAYMENT = gql`
  query GetUserRepaymentWeb(
    $limit: Int
    $offset: Int
    $filter: String
    $search: String
    $sort: SortInput
  ) {
    getUserRepaymentWeb(
      limit: $limit
      offset: $offset
      filter: $filter
      search: $search
      sort: $sort
    ) {
      count
      recentRepaymentDue {
        id
        transactions {
          txRef
          status
          paymentRef
          merchant {
            name
            logo
          }
          amount
        }
        loan {
          loanChannel
          order {
            orderNumber
            amount
          }
          merchant {
            name
            logo
          }
          amount
          id
          loanStatusId
          loanSchedules {
            loanId
          }
        }
        amountDue
        dueDate
        loanId
        isFullyPaid
        loan {
          id
          interest
          merchant {
            name
            logo
          }
        }
        originalAmount
      }
      repayments {
        id
        amountDue
        dueDate
        isFullyPaid
        originalAmount
        transactions {
          amount
          amountPaid
          merchant {
            logo
            name
          }
        }
        loan {
          id
          loanChannel
          loanStatus {
            name
          }
          interest
          userId
          merchant {
            name
            logo
          }
          order {
            orderNumber
            amount
            items
          }
        }
      }
    }
  }
`;

export const GET_ALL_CATEGORY = gql`
  query GetMerchantCategories {
    getMerchantCategories {
      name
      id
    }
  }
`;

export const GET_MERCHANT = gql`
  query Merchants($limit: Int, $offset: Int, $filter: String) {
    merchants(limit: $limit, offset: $offset, filter: $filter) {
      merchants {
        logo
        name
        id
        website
        categoryId
        paymentlinks {
          id
          name
          title
          description
          status
          amount
        }
      }
    }
  }
`;

export const GET_MERCHANT_WITH_PAYMENT_COUNT = gql`
  query Merchants($filter: String, $limit: Int, $offset: Int, $categoryId: ID) {
    getWebsitesMerchantsWithoutDocs(
      filter: $filter
      limit: $limit
      offset: $offset
      categoryId: $categoryId
    ) {
      merchants {
        id
        logo
        name
        bannerUrl
        categoryId
        categoryName
        paymentLinkCount
        website
      }
    }
  }
`;

export const GET_MERCHANTS_SHOP_LINKS = gql`
  query getMerchantShopLinks($id: ID!, $limit: Int!, $offset: Int!, $filter: String!) {
    getMerchantShopLinks(merchantId: $id, limit: $limit, offset: $offset, filter: $filter) {
      count
      paymentLinks {
        id
        name
        title
        description
        configurations
        merchantId
        createdAt
        images {
          url
        }
      }
    }
  }
`;

export const GET_VIRTUAL_ACCOUNT = gql`
  query GetVirtualAccount($amount: Float!, $loanScheduleId: String) {
    getVirtualAccount(amount: $amount, loanScheduleId: $loanScheduleId) {
      account
      accountName
      amount
      bankName
      bvn
      expiresIn
      paymentRef
      reference
      remainingTime
    }
  }
`;

export const CARDS = gql`
  query Cards {
    cards {
      cardBIN
      cardNo
      custEmail
      createdAt
      description
      expirymonth
      expiryyear
      id
      isDefault
      last4digits
      status
      token
      type
      userId
      verified
      user {
        accountNumber
      }
    }
  }
`;

export const GET_USER_UPLOADED_DOCUMENT_TYPES = gql`
  query Query {
    getUserUploadedDocumentTypes
  }
`;

export const GET_CURRENT_RNPL_VOUCHER = gql`
  query getCurrentRNPLVoucher {
    getCurrentRNPLVoucher {
      status
      message
      data {
        id
        voucherCode
        amount
        status
        userId
        loan {
          dueDate
          loanChannel
          loanSchedules {
            isFullyPaid
            dueDate
          }
          order {
            orderNumber
          }
          merchant {
            logo
            name
          }
          amount
          interest
        }
        loanId
      }
    }
  }
`;

export const GET_STATIC_VIRTUAL_ACCOUNT = gql`
  query GetStaticVirtualAccount {
    getStaticVirtualAccount {
      account
      accountName
      balance
      bankName
    }
  }
`;

export const BANK_DETAILS = gql`
  query BankDetails {
    getNyscUsersBankDetails {
      bankDetails {
        accountName
        accountNumber
        bank {
          abbreviation
          cbnCode
          createdAt
          id
          name
          nipCode
          updatedAt
        }
        bankId
        id
        status
        swiftCode
      }
    }
  }
`;

export const BANK_DETAILS_NORMAL_USER = gql`
  query BankDetails {
    getUserBankDetails {
      bankDetails {
        accountName
        accountNumber
        code
        createdAt
        id
        status
      }
    }
  }
`;

export const GET_USER_TRANSACTION_BY_ID = gql`
  query GetUserTransactionById($getUserTransactionByIdId: ID!) {
    getUserTransactionById(id: $getUserTransactionByIdId) {
      id
      type
      description
      narration
      message
      userId
      paymentRef
      txRef
      createdAt
      paymentMethod
      paymentFor
      status
      channel
      fees
      amount
      meta
      payout {
        amount
        id
        status
        narration
        destinationAccountName
        destinationAccountNumber
        apiResponse
        apiRequest
        service
        payout_reference
      }
    }
  }
`;

export const GET_FAQS = gql`
  query GetFaqs($limit: Int, $page: Int) {
    getFaqs(limit: $limit, page: $page) {
      faqs {
        attributes {
          answers
          category
          createdAt
          publishedAt
          questions
          serialNo
          title
          updatedAt
        }
        id
      }
      meta {
        pagination {
          page
          pageCount
          pageSize
          total
        }
      }
    }
  }
`;

export const GET_STATEMENT_PROVIDER_CONFIG = gql`
  query GetStatementProviderConfig {
    getStatementProviderConfig {
      data {
        createdAt
        id
        meta
        name
        type
        updatedAt
        value
      }
      message
      status
    }
  }
`;

export const GET_USER_NOTIFICATIONS = gql`
  query GetUserNotifications {
    getUserNotifications {
      createdAt
      id
      isDeleted
      isRead
      message
      reference
      subject
      updatedAt
      userId
    }
  }
`;

export const GET_MBS_BANK_LIST = gql`
  query GetMBSBankList {
    getMBSBankList {
      data {
        id
        name
        sortCode
      }
    }
  }
`;

export const GET_USER_REPAYMENT_WEB_CA = gql`
  query GetUserRepaymentWebCa(
    $limit: Int
    $offset: Int
    $filter: String
    $search: String
    $sort: SortInput
  ) {
    getUserRepaymentWebCa(
      limit: $limit
      offset: $offset
      filter: $filter
      search: $search
      sort: $sort
    ) {
      count
      repayments {
        id
        userId
        loanId
        payDate
        dueDate
        amountDue
        createdAt
        isFullyPaid
        loan {
          id
          userId
          propertyId
          loanAmount
          downPayment
          repaymentDuration
          loanStatusId
          moratoriumDuration
          hasFirstAndLastMonthPayment
          currency
          loanStartDate
          interest
          createdAt
          tenor
          loanStatus {
            name
          }
          property {
            rentAmount
            propertyAddress
            leaseStartDate
            hasleaseAgreementDoc
            leaseAgreementDoc
            currency
            landlord {
              firstName
              lastName
              email
              phone
            }
          }
        }
      }
      recentRepaymentDue {
        id
        userId
        loanId
        payDate
        dueDate
        amountDue
        createdAt
        isFullyPaid
        loan {
          id
          userId
          propertyId
          loanAmount
          downPayment
          repaymentDuration
          loanStatusId
          moratoriumDuration
          hasFirstAndLastMonthPayment
          currency
          loanStartDate
          interest
          createdAt
          tenor
          loanStatus {
            name
          }
          property {
            rentAmount
            propertyAddress
            leaseStartDate
            hasleaseAgreementDoc
            leaseAgreementDoc
            currency
            meta
            landlord {
              firstName
              lastName
              email
              phone
            }
          }
        }
      }
    }
  }
`;

export const GET_USER_GUARANTEE_REPAYMENT_WEB_CA = gql`
  query GetUserGuaranteeRepaymentWebCa(
    $limit: Int
    $offset: Int
    $filter: String
    $search: String
    $sort: SortInput
    $dateApplied: [String]
    $amountRange: AmountRangeFilter
    $amountType: String
  ) {
    getUserGuaranteeRepaymentWebCa(
      limit: $limit
      offset: $offset
      filter: $filter
      search: $search
      sort: $sort
      dateApplied: $dateApplied
      amountRange: $amountRange
      amountType: $amountType
    ) {
      count
      totalRepaymentLeft
      guaranteeRepayments {
        id
        userId
        loanId
        payDate
        dueDate
        amountDue
        createdAt
        isFullyPaid
        guarantee {
          tenor
          outstandingBalance
          paymentPlan
          downPayment
          meta
          id
          property {
            propertyAddress
            rentAmount
          }
        }
        transactions {
          meta
        }
      }
      recentGuaranteeRepaymentDue {
        id
        loanId
        userId
        payDate
        dueDate
        amountDue
        createdAt
        isFullyPaid
        guarantee {
          meta
          tenor
          outstandingBalance
          paymentPlan
          downPayment
          property {
            propertyAddress
          }
        }
        transactions {
          id
          meta
        }
      }
    }
  }
`;

export const GET_USER_TRANSACTIONS_CA = gql`
  query GetUserTransactionsCa(
    $search: String
    $limit: Int
    $offset: Int
    $statusFilter: String
    $dateApplied: [String]
    $amountRange: AmountRangeFilter
    $amountType: String
    $productTypes: ProductTypeFilter
  ) {
    getUserTransactionsCa(
      search: $search
      limit: $limit
      offset: $offset
      statusFilter: $statusFilter
      dateApplied: $dateApplied
      amountRange: $amountRange
      amountType: $amountType
      productTypes: $productTypes
    ) {
      count
      transactions {
        id
        userId
        loanId
        loanScheduleId
        txRef
        currency
        amount
        fees
        status
        narration
        description
        paymentMethod
        message
        meta
        createdAt
        updatedAt
        loan {
          id
          userId
          propertyId
          loanAmount
          downPayment
          repaymentDuration
          loanStatusId
          moratoriumDuration
          hasFirstAndLastMonthPayment
          currency
          loanStartDate
          interest
          createdAt
          tenor
          loanStatus {
            name
          }
          property {
            rentAmount
            propertyAddress
            leaseStartDate
            hasleaseAgreementDoc
            leaseAgreementDoc
            currency
            landlord {
              firstName
              lastName
              email
              phone
            }
          }
        }
      }
    }
  }
`;

export const GET_USER_CA_LOANS = gql`
  query GetUserCaLoans(
    $limit: Int
    $offset: Int
    $filters: FiltersType
    $search: String
    $statusFilter: String
  ) {
    getUserCaLoans(
      limit: $limit
      offset: $offset
      filters: $filters
      search: $search
      statusFilter: $statusFilter
    ) {
      count
      loans {
        id
        userId
        propertyId
        loanAmount
        downPayment
        repaymentDuration
        loanStatusId
        moratoriumDuration
        hasFirstAndLastMonthPayment
        currency
        loanStartDate
        interest
        createdAt
        meta
        loanStatus {
          name
        }
        property {
          rentAmount
          propertyAddress
          leaseStartDate
          hasleaseAgreementDoc
          leaseAgreementDoc
          currency
          meta
          landlord {
            firstName
            lastName
            email
            phone
          }
        }
        tenor
      }
    }
  }
`;

export const GET_USER_GUARANTEE = gql`
  query GetUserRentGuarantees(
    $limit: Int
    $offset: Int
    $search: String
    $statusFilter: String
    $userId: String
    $guaranteeType: String
    $dateApplied: [String]
    $amountRange: AmountRangeFilter
    $amountType: String
  ) {
    getUserRentGuarantees(
      limit: $limit
      offset: $offset
      search: $search
      statusFilter: $statusFilter
      userId: $userId
      guaranteeType: $guaranteeType
      dateApplied: $dateApplied
      amountRange: $amountRange
      amountType: $amountType
    ) {
      count
      rentGuarantees {
        id
        userId
        currency
        amount
        status
        propertyId
        monthlyRent
        monthlyBudget
        annualIncome
        guaranteeStartDate
        guaranteeEndDate
        guaranteeType
        approvedBy
        downPayment
        outstandingBalance
        preApprovalDocUrl
        meta
        createdAt
        updatedAt
        province
        cities
        property {
          id
          userId
          landlordId
          propertyAddress
          country
          city
          postalCode
          rentAmount
          leaseStartDate
          hasleaseAgreementDoc
          unitNumber
          landlord {
            firstName
            lastName
            email
            phone
            companyName
            landlordType
            website
            properties {
              id
              userId
              landlordId
              propertyAddress
              country
              city
              postalCode
              rentAmount
              leaseStartDate
              hasleaseAgreementDoc
              landlord {
                firstName
                lastName
                email
                phone
                website
                landlordType
                companyName
              }
            }
            id
          }
          leaseAgreementDoc
        }
      }
    }
  }
`;

export const GET_USER_APARTMENT_DETAILS = gql`
  query Data(
    $limit: Int
    $offset: Int
    $search: String
    $statusFilter: String
    $dateApplied: [String]
    $amountRange: AmountRangeFilter
    $amountType: String
    $propertyTypes: PropertyTypeFilter
  ) {
    getUserApartmentDetails(
      limit: $limit
      offset: $offset
      search: $search
      statusFilter: $statusFilter
      dateApplied: $dateApplied
      amountRange: $amountRange
      amountType: $amountType
      propertyTypes: $propertyTypes
    ) {
      data {
        rows {
          additionalInformation
          apartmentType
          city
          id
          lastActionedAt
          lastActionedBy
          meta
          monthlyBudget
          monthlyIncome
          paymentAmount
          province
          refundedAt
          status
          userId
          user {
            phone
            email
            firstName
            id
            lastName
            imageUrl
          }
        }
        count
      }
    }
  }
`;

export const GET_USER_RENT_GUARANTEE_DETAILS = gql`
  query GetUserRentGuaranteeSingle($getUserRentGuaranteeSingleId: String!) {
    getUserRentGuaranteeSingle(id: $getUserRentGuaranteeSingleId) {
      data {
        meta
        amount
        annualIncome
        createdAt
        property {
          propertyAddress
        }
      }
      message
      status
    }
  }
`;

export const GET_USER_APARTMENT_SINGLE_DETAILS = gql`
  query GetApartmentDetailSingle($getApartmentDetailSingleId: String!) {
    getApartmentDetailSingle(id: $getApartmentDetailSingleId) {
      status
      message
      data {
        userId
        transaction {
          id
          txRef
          status
          amount
        }
        id
        paymentAmount
        monthlyIncome
        meta
        monthlyBudget
        city
        additionalInformation
        apartmentType
        refundedAt
        province
        status
      }
    }
  }
`;

export const GET_USER_RECENT_TRANSACTION = gql`
  query GetUserRecentTransaction {
    getUserRecentTransaction {
      txRef
      status
      productType
      id
      currency
      createdAt
      amount
    }
  }
`;

export const GET_USER_REFERRALS_CLIENT = gql`
  query GetUserReferralsClient {
    getUserReferralsClient {
      totalReferrals
      status
    }
  }
`;

export const GET_USER_TENANCY_REQUEST = gql`
  query GetUserAllTenancyRequest($filter: TenantRequestFilters) {
    getUserAllTenancyRequest(filter: $filter) {
      status
      message
      data {
        count
        tenants {
          id
          propertyId
          realtorId
          property {
            propertyName
          }
          PADStatus
          rentProtection
          landlord {
            firstName
            lastName
          }
          rentAmount
        }
      }
    }
  }
`;

export const GET_USER_WALLET_CLIENT = gql`
  query GetUserWalletClient {
    getUserWalletClient {
      status
      message
      balance
    }
  }
`;

export const GET_TOTAL_PAYMENT_MADE = gql`
  query GetTotalPaymentMade {
    getTotalPaymentMade {
      totalPayment
      status
      message
    }
  }
`;

export const GET_WALLET_TRANSACTIONS = gql`
  query GetWalletTransactions(
    $limit: Int
    $offset: Int
    $statusFilter: String
    $search: String
    $dateApplied: [String]
    $amountRange: AmountRangeFilter
    $amountType: String
  ) {
    getWalletTransactions(
      limit: $limit
      offset: $offset
      statusFilter: $statusFilter
      search: $search
      dateApplied: $dateApplied
      amountRange: $amountRange
      amountType: $amountType
    ) {
      status
      message
      data {
        count
        transactions {
          id
          userId
          loanId
          loanScheduleId
          txRef
          currency
          amount
          fees
          status
          narration
          description
          paymentMethod
          message
          walletId
          paymentFor
          meta
          createdAt
          updatedAt
          user {
            firstName
            lastName
            email
          }
        }
      }
    }
  }
`;

export const GET_WALLET_DASHBOARD = gql`
  query GetWalletDashboard {
    getWalletDashboard {
      status
      message
      data {
        withdrawal
        referrals
        incentives
      }
    }
  }
`;

export const GET_REFERRAL_DASHBOARD = gql`
  query GetReferralDashboard(
    $limit: Int
    $offset: Int
    $search: String
    $statusFilter: String
    $dateApplied: [String]
    $amountRange: AmountRangeFilter
    $amountType: String
  ) {
    getReferralDashboard(
      limit: $limit
      offset: $offset
      search: $search
      statusFilter: $statusFilter
      dateApplied: $dateApplied
      amountRange: $amountRange
      amountType: $amountType
    ) {
      message
      referralDetail {
        completedReferrals
        createdAt
        earnings
        balance
        meta
        id
        referralCode
        totalReferred
        updatedAt
        userId
      }
      referrals {
        count
        rows {
          createdAt
          dateApproved
          earning
          id
          meta
          referralDetailId
          status
          updatedAt
          userId
          referred {
            email
            firstName
            lastName
          }
        }
      }
      status
    }
  }
`;

export const GET_USER_FUND_DOC = gql`
  query UserHasFundDocumentCa {
    userHasFundDocumentCa {
      status
      message
      data {
        id
        meta {
          file_size
        }
      }
      hasFundDoc
    }
  }
`;

export const GET_RENT_PAYMENT_DASHBOARD = gql`
  query GetRentPaymentDashboard {
    getRentPaymentDashboard {
      data {
        monthlyRentAmount
        rentPaymentFrequency
        totalRentPaid
        rentDueDate
        rentDueIn
        currentRewardPoint
        equivalentPointAmount
      }
      message
      status
    }
  }
`;

export const GET_ALL_REALTOR_PROPERTY_LISTING = gql`
  query GetAllRealtorPropertiesListing(
    $limit: Int
    $offset: Int
    $statusFilter: String
    $search: String
  ) {
    getAllRealtorPropertiesListing(
      limit: $limit
      offset: $offset
      statusFilter: $statusFilter
      search: $search
    ) {
      data {
        count
        rows {
          id
          bedroomCount
          city
          description
          propertyName
          propertyType
          unitAvaialable
          roomAvailability
          state
          typeOfHome
          rentAmount
          otherFeatures
          unitSize
          rentalAddress
          managerFullName
          managerEmail
          managerPhone
          createdAt
          realtorPropertyImages {
            id
            imageType
            realtorPropertyId
            s3Url
          }
        }
      }
    }
  }
`;

export const GET_REALTOR_PROPERTY_BY_ID_PUBLIC = gql`
  query GetRealtorPropertyByIdPublic($getRealtorPropertyByIdPublicId: ID!) {
    getRealtorPropertyByIdPublic(id: $getRealtorPropertyByIdPublicId) {
      message
      otherPropertyListing {
        bedroomCount
        city
        createdAt
        description
        distance
        id
        keyFeatures
        managerEmail
        managerFullName
        managerPhone
        otherFeatures
        propertyName
        propertyType
        realtorPropertyImages {
          id
          imageType
          realtorPropertyId
          s3Url
        }
        roomAvailability
        state
        typeOfHome
        unitAvaialable
        unitSize
        unitUsed
        realtorPropertyBedroomDetail {
          bedCount
          id
          minimumStay
          preferredGender
          privateBath
          realtorPropertyBedroomImages {
            id
            realtorPropertyBedroomId
            realtorPropertyId
            s3Url
          }
          rentAmount
          roomAlias
          roomDetails
          roomName
        }
      }
      realtorProperty {
        bedroomCount
        city
        createLevel
        createLevelRedirect
        createdAt
        description
        distance
        state
        id
        keyFeatures
        managerEmail
        managerFullName
        managerPhone
        otherFeatures
        propertyName
        propertyType
        realtorId
        realtorPropertyImages {
          id
          imageType
          realtorPropertyId
          s3Url
        }
        rentAmount
        roomAvailability
        typeOfHome
        unitAvaialable
        unitSize
        unitUsed
      }
    }
  }
`;

export const GET_USER_RENT_PAYMENTS = gql`
  query GetUserRentPayments(
    $limit: Int
    $offset: Int
    $search: String
    $statusFilter: String
    $dateApplied: [String]
    $amountRange: AmountRangeFilter
    $amountType: String
  ) {
    getUserRentPayments(
      limit: $limit
      offset: $offset
      search: $search
      statusFilter: $statusFilter
      dateApplied: $dateApplied
      amountRange: $amountRange
      amountType: $amountType
    ) {
      status
      message
      data {
        count
        rows {
          createdAt
          id
          paymentRef
          propertyId
          rentAmount
          status
          userId
          receiptUrl
          meta
          property {
            propertyAddress
            landlordModeOfPayment
            landlord_e_transfer_email
            unitNumber
            landlord {
              companyName
              firstName
              email
              id
              landlordType
              lastName
              phone
            }
          }
          tenant {
            id
            unit
            property {
              id
              rentalAddress
            }
            account {
              id
              type
              email
            }
            landlord {
              firstName
              email
              id
              lastName
              phone
            }
          }
        }
      }
    }
  }
`;

export const GET_RECENT_PROPERTY_DETAILS = gql`
  query getRecentPropertyDetails {
    getRecentPropertyDetails {
      data {
        leaseAgreementDoc
        landlord_e_transfer_email
        hasleaseAgreementDoc
        propertyAddress
        rentAmount
        unitNumber
        currency
        id
        leaseStartDate
        meta
        postalCode
        landlord {
          companyName
          firstName
          id
          landlordType
          lastName
          phone
          email
        }
      }
      message
      status
    }
  }
`;

export const VALIDATE_TRANSACTION_PUBLIC = gql`
  query validateTransactionPublic($transactionId: String!) {
    validateTransactionPublic(transactionId: $transactionId) {
      status
      message
      data {
        status
        amount
        paymentRef
        txRef
        paymentLink
      }
    }
  }
`;

export const GENERATE_RENT_PAYMENT_RECEIPT = gql`
  query GenerateRentPaymentReceipt($rentPaymentId: String!) {
    generateRentPaymentReceipt(rentPaymentId: $rentPaymentId) {
      data {
        id
        receiptUrl
      }
      message
      status
    }
  }
`;

export const GET_ONBOARDING_PRESETS = gql`
  query getOnboardingPresets {
    getOnboardingPresets {
      status
      message
      data {
        apartmentTypes
        documentData
        employmentStatus
        enrollmentTypes
        genders
        leasePeriods
        modeOfPayments
        products
        employmentStatus
        enrollmentTypes
        apartmentSearchProvinces
        leasePeriods
        apartmentTypes
        provinces
        security_questions
      }
    }
  }
`;

export const GET_RENT_REWARD = gql`
  query GetRentReward {
    getRentReward {
      data {
        currentPoints
        equivalentEarnings
        level
        levelName
        totalEarnings
        totalPointsAccumulated
      }
      message
      status
    }
  }
`;

export const GET_RENT_REWARD_HISTORY = gql`
  query GetRentRewardHistory($limit: Int, $offset: Int) {
    getRentRewardHistory(limit: $limit, offset: $offset) {
      count
      data {
        closingPoints
        createdAt
        updatedAt
        equivalentAmount
        id
        openingPoints
        points
        rentRewardId
        rewardType
        status
        transactionId
        type
        userId
      }
    }
  }
`;

export const GET_MERCHANT_RENT_PAYMENT_DETAILS = gql`
  query getMerchantRentPaymentByTransactionRef($transactionReference: String!) {
    getMerchantRentPaymentByTransactionRef(transactionReference: $transactionReference) {
      status
      message
      data {
        paymentLink
        reference
        interacId
        interacAmount
        type
        redirectUrl
        id
      }
    }
  }
`;
export const GET_RENT_REWARD_REDEMPTION_HISTORY = gql`
  query GetRentRewardRedemptionHistory($limit: Int, $offset: Int) {
    getRentRewardRedemptionHistory(limit: $limit, offset: $offset) {
      count
      data {
        createdAt
        email
        equivalentAmount
        id
        meta
        points
        referenceId
        rentRewardHistoryId
        status
        type
        updatedAt
        userId
      }
    }
  }
`;

export const INITIATE_RENT_REWARD_REDEMPTION = gql`
  query InitiateRentRewardRedemption {
    initiateRentRewardRedemption {
      description
      identifier
    }
  }
`;

export const GET_TANGO_CATEGORY_CATALOG = gql`
  query GetTangoCategoryCatalog($categoryId: ID!) {
    getTangoCategoryCatalog(categoryId: $categoryId) {
      catalogName
      brands {
        brandKey
        brandName
        brandRequirements
        createdDate
        categories {
          description
          identifier
        }
        description
        disclaimer
        imageUrls
        items {
          countries
          createdDate
          credentialTypes
          currencyCode
          fulfillmentType
          isWholeAmountValueRequired
          lastUpdateDate
          maxValue
          minValue
          redemptionInstructions
          rewardName
          rewardType
          status
          utid
          valueType
          faceValue
        }
        lastUpdateDate
        shortDescription
        status
        terms
      }
    }
  }
`;

export const GET_ORDER_DETAILS = gql`
  query GetOrderDetails($reference: String!) {
    getOrderDetails(reference: $reference) {
      accountIdentifier
      accountNumber
      createdAt
      customerIdentifier
      etid
      externalRefID
      referenceOrderID
      rewardName
      sendEmail
      status
      utid
      amountCharged {
        currencyCode
        total
        value
      }
      denomination {
        currencyCode
        value
      }
      recipient {
        address
        email
        firstName
        lastName
      }
      reward {
        credentialList
        credentials
        redemptionInstructions
      }
      sender
    }
  }
`;

export const VERIFY_USER_REWARD = gql`
  query VerifyUserReward {
    verifyUserReward {
      status
    }
  }
`;

export const GET_TANGO_CATALOG_BY_UTID = gql`
  query GetTangoCatalogByUtid($utid: ID) {
    getTangoCatalogByUtid(utid: $utid) {
      brands {
        terms
        status
        shortDescription
        lastUpdateDate
        items {
          countries
          createdDate
          credentialTypes
          currencyCode
          fulfillmentType
          isWholeAmountValueRequired
          lastUpdateDate
          maxValue
          minValue
          redemptionInstructions
          rewardName
          rewardType
          status
          utid
          valueType
          faceValue
        }
        brandKey
        brandName
        brandRequirements
        categories {
          description
          identifier
        }
        createdDate
        description
        disclaimer
        imageUrls
      }
    }
  }
`;

export const GET_BILL_PAYMENTS_CA = gql`
  query GetBillPaymentsCa($limit: Int, $offset: Int, $filter: BillPaymentFilter) {
    getBillPaymentsCa(limit: $limit, offset: $offset, filter: $filter) {
      all
      failed
      pending
      success
      billPayments {
        count
        data {
          amount
          biller
          createdAt
          currency
          fee
          status
          id
          meta
        }
      }
    }
  }
`;

export const GET_BENEFICIARIES_CA = gql`
  query GetBeneficiariesCa($limit: Int, $offset: Int) {
    getBeneficiariesCa(limit: $limit, offset: $offset) {
      beneficiaries {
        count
        data {
          payeeName
          payeeCode
          accountId
          createdAt
          id
          lastAmountPaid
          nickName
          updatedAt
          userId
        }
      }
    }
  }
`;

export const GET_BILLERS_CA = gql`
  query Query($search: String!) {
    getBillersCa(search: $search)
  }
`;

export const GET_FREQUEST_BILL_CA = gql`
  query GetFrequestBillPaymentsCa {
    getFrequestBillPaymentsCa {
      amount
      biller
      billerCode
      createdAt
      currency
      datePaid
      fee
      id
      meta
      narration
      status
      updatedAt
      userId
      accountId
    }
  }
`;

export const GENERATE_BILL_RECEIPT = gql`
  query GenerateBillReceipt($billPaymentId: String!) {
    generateBillReceipt(billPaymentId: $billPaymentId) {
      statusCode
      status
      message
      data
    }
  }
`;
